<div class="page-content-wrapper">
    <div class="card rounded-3 border-1 shadow">
        <div class="card-header bg-white border-0 me-2 d-flex justify-content-between align-items-center">
            <p class="text-s fw-bold">Workflows</p>
            <button
                v-if="isSystemAdmin"
                type="button"
                class="btn btn-dark rounded-3 fw-bold text-xxs shadow"
                @click="openImportModal"
                data-bs-toggle="modal"
                data-bs-target="#import_workflow_modal"
            >
                <i class="fas fa-file-import me-1"></i> Import Workflow
            </button>
        </div>
        <div class="card-body">
            <CustomTabs
                :tabs="tabs"
                v-model="currentTab"
            />
            <div class="tab-content ms-2 me-2">
                <CustomTable
                    :columns="columns"
                    :fetchData="get_workflows"
                    :key="`${currentTab}_${workflowsTableKey}`"
                    :hasActions="true"
                    :tableKey="`workflows_${currentTab}`"
                    >
                    <template v-slot:cell-date_created="{ row }">
                        {{ formatDate(row.date_created) }}
                    </template>
                    <template v-slot:cell-is_active="{ row }">
                        <span
                            :class="[
                            'badge', 'shadow',
                            row.is_active ? 'bg-success' : 'bg-danger']">
                            {{ row.is_active ? 'Active' : 'Inactive' }}
                        </span>
                    </template>
                    <template v-slot:actions="{ row }">
                        <button
                        class="btn bg-green btn-sm text-xxs rounded-3 fw-bold shadow me-1"
                        @click="view_workflow_information(row.id)"
                        >View
                        </button>
                        <span v-if="currentTab === 'approved'">
                            <button
                            class="btn bg-info text-white btn-sm text-xxs fw-bold shadow rounded-3"
                            @click="view_workflow_clients(row.id)"
                            >Customers
                            </button>
                            <button
                            class="btn bg-dark btn-sm text-xxs rounded-3 fw-bold shadow text-white ms-1"
                            @click="view_workflow_notifications(row.id)">
                            Notifications
                            </button>
                        </span>
                    </template>
                </CustomTable>
            </div>
        </div>
    </div>
</div>

<!-- Import Workflow Modal -->
<div class="modal fade" id="import_workflow_modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="import_workflow_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-white rounded-4 border-0 shadow-lg">
            <!-- Header -->
            <div class="modal-header border-0 pb-0 pt-4 px-4">
                <h5 class="modal-title fw-bold modal-title-large" id="import_workflow_label">
                    Upload file
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetImportForm"></button>
            </div>

            <div class="modal-body px-4 pt-3 pb-4">
                <!-- Project Selector - Searchable -->
                <div class="form-group mb-4 position-relative">
                    <label class="form-label text-xs fw-semibold text-secondary mb-2">Select Project <span class="text-danger">*</span></label>
                    <div class="position-relative">
                        <div 
                            class="form-control d-flex align-items-center justify-content-between text-xs rounded-3 py-2 px-3 border project-selector-field"
                            :class="{ 'project-selector-field focused': showProjectDropdown }"
                            @click="toggleProjectDropdown"
                        >
                            <span :class="{ 'text-secondary': !selectedProjectId }">
                                {{ selectedProjectName || '-- Select a project --' }}
                            </span>
                            <i class="fas fa-chevron-down text-secondary chevron-icon" :style="{ transform: showProjectDropdown ? 'rotate(180deg)' : 'rotate(0)' }"></i>
                        </div>
                        
                        <!-- Dropdown -->
                        <div 
                            v-show="showProjectDropdown" 
                            class="position-absolute w-100 bg-white rounded-3 shadow-lg border mt-1 project-dropdown-menu"
                        >
                            <!-- Search Input -->
                            <div class="p-2 border-bottom">
                                <div class="position-relative">
                                    <i class="fas fa-search position-absolute text-secondary search-icon"></i>
                                    <input 
                                        type="text" 
                                        v-model="projectSearchQuery"
                                        class="form-control text-xs rounded-2 py-2 ps-4 pe-3 border-0 project-search-input"
                                        placeholder="Search projects..."
                                        @click.stop
                                        ref="projectSearchInput"
                                    >
                                </div>
                            </div>
                            
                            <!-- Project List -->
                            <div class="overflow-auto project-list">
                                <div v-if="loadingProjects" class="p-3 text-center text-secondary text-xxs">
                                    <i class="fas fa-spinner fa-spin me-1"></i>Loading projects...
                                </div>
                                <div v-else-if="projects.length === 0" class="p-3 text-center text-secondary text-xxs">
                                    <i class="fas fa-search me-1"></i>No projects found
                                </div>
                                <div 
                                    v-else
                                    v-for="project in projects" 
                                    :key="project.id"
                                    class="px-3 py-2 text-xs project-option d-flex align-items-center"
                                    :class="{ 'project-option selected': selectedProjectId === project.id }"
                                    @click="selectProject(project)"
                                >
                                    <div class="project-icon me-2 d-flex align-items-center justify-content-center rounded-2">
                                        <i class="fas fa-folder folder-icon"></i>
                                    </div>
                                    <div class="flex-grow-1">
                                        <p class="mb-0 fw-medium">{{ project.project_name }}</p>
                                        <p v-if="project.company_name" class="mb-0 text-xxs text-secondary">{{ project.company_name }}</p>
                                    </div>
                                    <i v-if="selectedProjectId === project.id" class="fas fa-check text-primary check-icon"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Click outside handler -->
                    <div v-if="showProjectDropdown" class="position-fixed top-0 start-0 w-100 h-100 click-outside-overlay" @click="showProjectDropdown = false"></div>
                </div>

                <!-- Drag & Drop Zone -->
                <div 
                    class="upload-dropzone position-relative rounded-3 mb-3"
                    :class="{ 'dropzone-active': isDragging, 'dropzone-has-file': uploadedFile }"
                    @dragenter.prevent="handleDragEnter"
                    @dragover.prevent="handleDragOver"
                    @dragleave.prevent="handleDragLeave"
                    @drop.prevent="handleDrop"
                    @click="$refs.jsonFileInput.click()"
                >
                    <input 
                        type="file" 
                        ref="jsonFileInput"
                        class="d-none" 
                        accept=".json,application/json"
                        @change="parseJsonFile"
                    >
                    
                    <!-- Upload Content -->
                    <div v-if="!uploadedFile" class="d-flex flex-column align-items-center justify-content-center h-100 py-5">
                        <div class="upload-icon-wrapper mb-3 position-relative">
                            <div class="file-icon d-flex align-items-center justify-content-center">
                                <i class="fas fa-file text-muted file-icon-default"></i>
                            </div>
                            <div class="upload-badge upload-badge-pending position-absolute d-flex align-items-center justify-content-center rounded-circle">
                                <i class="fas fa-arrow-up text-white icon-sm"></i>
                            </div>
                        </div>
                        <p class="text-secondary text-xs mb-0">
                            Drag and Drop file here or <span class="text-decoration-underline fw-semibold upload-text-link">Choose file</span>
                        </p>
                    </div>

                    <!-- File Selected State -->
                    <div v-else class="d-flex flex-column align-items-center justify-content-center h-100 py-5">
                        <div class="upload-icon-wrapper mb-3 position-relative">
                            <div class="file-icon d-flex align-items-center justify-content-center">
                                <i class="fas fa-file-code file-icon-success"></i>
                            </div>
                            <div class="upload-badge upload-badge-success position-absolute d-flex align-items-center justify-content-center rounded-circle">
                                <i class="fas fa-check text-white icon-sm"></i>
                            </div>
                        </div>
                        <p class="text-secondary text-xs mb-0">
                            Drag and Drop file here or <span class="text-decoration-underline fw-semibold upload-text-link">Choose file</span>
                        </p>
                    </div>
                </div>

                <!-- File Format Info -->
                <div class="d-flex justify-content-between align-items-center mb-4 text-xxs text-secondary">
                    <span>Supported formats: JSON</span>
                    <span>Maximum size: 10MB</span>
                </div>

                <!-- Uploaded File Card -->
                <div v-if="uploadedFile" class="uploaded-file-card border rounded-3 p-3 mb-4">
                    <div class="d-flex align-items-center">
                        <div class="file-icon-sm me-3 d-flex align-items-center justify-content-center rounded-2">
                            <i class="fas fa-file-code file-code-icon"></i>
                        </div>
                        <div class="flex-grow-1 me-3">
                            <p class="mb-1 text-xs fw-semibold text-dark file-name-text">{{ uploadedFile.name }}</p>
                            <p class="mb-0 text-xxs text-secondary">{{ formatFileSize(uploadedFile.size) }}</p>
                        </div>
                        <button 
                            type="button" 
                            class="btn btn-sm p-1 remove-file-btn" 
                            @click="removeUploadedFile"
                        >
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    <!-- Upload Progress -->
                    <div v-if="uploadProgress < 100" class="mt-2">
                        <div class="progress progress-container">
                            <div 
                                class="progress-bar progress-bar-primary"
                                role="progressbar" 
                                :style="{ width: uploadProgress + '%' }"
                            ></div>
                        </div>
                        <p class="text-end mb-0 mt-1 text-xxs text-secondary">{{ uploadProgress }}%</p>
                    </div>
                </div>

                <!-- Preview Section - Carousel Style -->
                <div v-if="parsedWorkflow" class="preview-carousel mb-4">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="fw-bold text-xs mb-0 text-secondary">
                            <i class="fas fa-eye me-2"></i>Preview
                        </h6>
                        <div class="carousel-nav" v-if="parsedWorkflow.services?.length > 0">
                            <span class="text-xxs text-secondary me-2">{{ currentPreviewSlide + 1 }} of {{ previewSlides.length }}</span>
                            <button 
                                class="btn btn-sm btn-outline-secondary rounded-circle p-0 me-1 carousel-nav-btn"
                                :disabled="currentPreviewSlide === 0"
                                @click="prevPreviewSlide"
                            >
                                <i class="fas fa-chevron-left icon-chevron"></i>
                            </button>
                            <button 
                                class="btn btn-sm btn-outline-secondary rounded-circle p-0 carousel-nav-btn"
                                :disabled="currentPreviewSlide >= previewSlides.length - 1"
                                @click="nextPreviewSlide"
                            >
                                <i class="fas fa-chevron-right icon-chevron"></i>
                            </button>
                        </div>
                    </div>
                    
                    <!-- Carousel Cards Container -->
                    <div class="preview-cards-wrapper overflow-hidden">
                        <div 
                            class="preview-cards-track d-flex transition-transform carousel-transform"
                            :style="{ transform: `translateX(-${currentPreviewSlide * 100}%)` }"
                        >
                            <!-- Workflow Info Card -->
                            <div class="preview-card flex-shrink-0 w-100">
                                <div class="card border-0 rounded-3 shadow-sm preview-gradient-card">
                                    <div class="card-body p-4 text-white">
                                        <div class="d-flex align-items-center mb-3">
                                            <div class="icon-wrapper rounded-circle d-flex align-items-center justify-content-center me-3 preview-icon-wrapper">
                                                <i class="fas fa-project-diagram project-diagram-icon"></i>
                                            </div>
                                            <div>
                                                <p class="mb-0 text-xxs opacity-medium">Workflow</p>
                                                <h6 class="mb-0 fw-bold text-s">{{ parsedWorkflow.workflow_name }}</h6>
                                            </div>
                                        </div>
                                        <p class="text-xs mb-3 opacity-high">{{ parsedWorkflow.workflow_description }}</p>
                                        <div class="d-flex gap-3">
                                            <div class="stat-item">
                                                <p class="mb-0 text-xxs opacity-low">Type</p>
                                                <p class="mb-0 text-xs fw-semibold">{{ parsedWorkflow.workflow_type || 'Standard' }}</p>
                                            </div>
                                            <div class="stat-item">
                                                <p class="mb-0 text-xxs opacity-low">Services</p>
                                                <p class="mb-0 text-xs fw-semibold">{{ parsedWorkflow.services?.length || 0 }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Service Cards -->
                            <div 
                                v-for="(serviceGroup, groupIndex) in serviceGroups" 
                                :key="groupIndex"
                                class="preview-card flex-shrink-0 w-100"
                            >
                                <div class="card border rounded-3 h-100 preview-service-card">
                                    <div class="card-body p-4">
                                        <div class="d-flex align-items-center mb-3">
                                            <div class="icon-wrapper rounded-circle d-flex align-items-center justify-content-center me-3 preview-service-icon">
                                                <i class="fas fa-cogs cogs-icon"></i>
                                            </div>
                                            <h6 class="mb-0 fw-bold text-xs">Services ({{ groupIndex * 4 + 1 }}-{{ Math.min((groupIndex + 1) * 4, parsedWorkflow.services.length) }})</h6>
                                        </div>
                                        <div class="services-list">
                                            <div 
                                                v-for="(service, idx) in serviceGroup" 
                                                :key="idx"
                                                class="service-item d-flex align-items-center py-2 px-3 mb-2 rounded-2"
                                            >
                                                <div class="service-number rounded-circle d-flex align-items-center justify-content-center me-3">
                                                    {{ groupIndex * 4 + idx + 1 }}
                                                </div>
                                                <span class="text-xs">{{ service.service_name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Carousel Dots -->
                    <div v-if="previewSlides.length > 1" class="carousel-dots d-flex justify-content-center mt-3 gap-2">
                        <button 
                            v-for="(slide, index) in previewSlides" 
                            :key="index"
                            class="dot-btn rounded-circle p-0 border-0"
                            :class="{ 'active': currentPreviewSlide === index }"
                            @click="goToPreviewSlide(index)"
                        ></button>
                    </div>
                </div>

                <!-- Validation Error -->
                <div v-if="validationError" class="alert alert-danger rounded-3 mb-3 d-flex align-items-center" role="alert">
                    <i class="fas fa-exclamation-circle me-2"></i>
                    <span class="text-xs">{{ validationError }}</span>
                </div>

                <!-- Success Message -->
                <div v-if="importSuccess" class="alert alert-success rounded-3 mb-3 d-flex align-items-center" role="alert">
                    <i class="fas fa-check-circle me-2"></i>
                    <span class="text-xs">{{ importSuccess }}</span>
                </div>

                <!-- Warning for skipped services -->
                <div v-if="servicesNotFound.length" class="alert alert-warning rounded-3 mb-3">
                    <div class="d-flex align-items-center mb-2">
                        <i class="fas fa-exclamation-triangle me-2"></i>
                        <span class="fw-bold text-xs">Some services were not found</span>
                    </div>
                    <ul class="mb-0 text-xxs ps-4">
                        <li v-for="(service, index) in servicesNotFound" :key="index">{{ service }}</li>
                    </ul>
                </div>

                <!-- Example Template Download -->
                <div class="template-download d-flex align-items-center justify-content-between p-3 rounded-3 border">
                    <div class="d-flex align-items-center">
                        <div class="template-icon me-3 d-flex align-items-center justify-content-center rounded-2">
                            <i class="fas fa-file-code template-icon-color"></i>
                        </div>
                        <div>
                            <p class="mb-0 text-xs fw-semibold">JSON Template</p>
                            <p class="mb-0 text-xxs text-secondary">Use this as a starting point for your workflow</p>
                        </div>
                    </div>
                    <button 
                        type="button" 
                        class="btn btn-outline-dark btn-sm rounded-3 text-xxs fw-semibold px-3"
                        @click="downloadTemplate"
                    >
                        Download
                    </button>
                </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer border-0 px-4 pb-4 pt-0 d-flex justify-content-between">
                <div class="d-flex gap-2">
                    <button 
                        type="button" 
                        class="btn btn-outline-secondary rounded-3 text-xs fw-semibold px-4" 
                        data-bs-dismiss="modal"
                        @click="resetImportForm"
                    >
                        Cancel
                    </button>
                    <button 
                        type="button" 
                        class="btn rounded-3 text-xs fw-semibold px-4 text-white"
                        :class="{ 'btn-secondary': !canImport, 'bg-green': canImport }"
                        :disabled="!canImport || importing"
                        @click="importWorkflow"
                    >
                        <span v-if="importing">
                            <i class="fas fa-spinner fa-spin me-1"></i>Importing...
                        </span>
                        <span v-else>
                            Next
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>